module.exports = __webpack_public_path__ + "static/img/5.6b3559f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/5/1/eng/5.png
// module id = l+D1
// module chunks = 0